"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelegatedPublicKeysClient = void 0;
const baseAuthApi_1 = require("../../baseAuthApi");
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class DelegatedPublicKeysClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async getPublicKeyById(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId', {
            path: { publicKeyId: request.publicKeyId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPublicKeyInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys', {
            path: {},
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createPublicKeyComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys', {
            path: {},
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPublicKeys() {
        const path = (0, url_1.buildPathAndQuery)('/public-keys', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getAddressForNetwork(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/address', {
            path: { publicKeyId: request.publicKeyId },
            query: request.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getSignatureById(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/signatures/:signatureId', {
            path: {
                publicKeyId: request.publicKeyId,
                signatureId: request.signatureId,
            },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createSignatureInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/signatures', {
            path: { publicKeyId: request.publicKeyId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createSignatureComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/signatures', {
            path: { publicKeyId: request.publicKeyId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async startWalletConnectSessionInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/walletconnect-session', {
            path: { publicKeyId: request.publicKeyId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async startWalletConnectSessionComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/walletconnect-session', {
            path: { publicKeyId: request.publicKeyId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listTransactions(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/:publicKeyId/transactions', {
            path: { publicKeyId: request.publicKeyId },
            query: request.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createTransactionInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/transactions', {
            path: {},
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createTransactionComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/transactions', {
            path: {},
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getTransactionById(request) {
        const path = (0, url_1.buildPathAndQuery)('/public-keys/transactions/:transactionId', {
            path: { transactionId: request.transactionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.DelegatedPublicKeysClient = DelegatedPublicKeysClient;
